import { Fragment, useState, useEffect} from 'react';
import { Layout, Spinner, List, Stack } from '@shopify/polaris';
import { PLAN_ENTERPRISE, PLAN_SMALL_BUSINESS } from '../../../constants/constants';

const PlanComponent = (props: any) => {

  const KeyFeaturesComponent = () => {
    return (
      <tr className='Polaris-DataTable__TableRow detailed_plan_info'>
        <td className='Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop'>
          <p className='strong pb-2 includedTextCss'>
            {props.planDetails.included ? props.planDetails.included : ''}
          </p>
          <div className='featuresPoints'>
            <List>
              {props.planDetails.key_features.map((feat: any, index: any) => {
                return <List.Item key={index}>{feat}</List.Item>;
              })}
            </List>
          </div>
        </td>
      </tr>
    );
  };

  const ButtonCss = (r_button: boolean) => {
    if (r_button) {
      return `Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignMiddle text-center p-0 absolute align-at-top`;
    }
    return ``;
  };

  const renderButtonCSS = (r_button: boolean, isDisable: boolean) => {
    if (r_button) {
      return `Polaris-Button Polaris-Button--primary plan-recommend-btn`;
    }
    return `planButtonCss ${isDisable ? 'plan-btn-disabled' : ''}`;
  };

  const showRecommendedPlanButton = () => {
    return (
      <div className={ButtonCss(true)}>
        <button
          onClick={() =>
            Number(props.planId) === PLAN_ENTERPRISE
              ? props.contactUs()
              : props.handleUpdatePlan(props.planId , props.page)
          }
          className={`${renderButtonCSS(true, true)} ${
            props.currentPlanId === props.planId ? 'pointerNone' : ''
          }`}
          type='button'
          disabled={true}
        >
          <span className='Polaris-Button__Content'>
            <span className='Polaris-Button__Text'>Recommended</span>
          </span>
          {props.isLoading && props.selectedPlanId === props.planId && (
            <span className='ml-1'>
              <Spinner size='small' />
            </span>
          )}
        </button>
      </div>
    );
  };

  return (
    <Fragment>
       <Layout.Section oneThird key={props.index} >
        <div
          className={`Polaris-Card basic-tile ${
            props.planDetails.recommended === true
              ? 'plan-rec-card'
              : 'plan-gen-card'
          }`}
        >
          <div className='Polaris-Card__Header'>
            <div className='Polaris-Heading card-heading mt-2'>
              {props.planDetails.planName}
            </div>
          </div>
          <div className='iconCSS'>
            <img
              src={props.planDetails.icon}
              alt='profile'
              width='65px'
              height='65px'
            />
          </div>
          <div className='Polaris-Card__Section cardHeight'>
            {props.planDetails.currency ? (
              <p className='plan_price_1'>
                <span className='sup'>{props.planDetails.currency}</span>
                {props.planDetails.price}
                <span className='plan_price_month_1'>
                  /{props.planDetails.sub_interval}
                </span>
              </p>
            ) : (
              <p className='plan_price_1_noPrice'>{props.planDetails.price}</p>
            )}
            {props.planDetails.additionalCharges ? (
              <div className='additionalCharges'>
                <p>{props.planDetails.additionalCharges}</p>
              </div>
              ) : ('')
            }
            <KeyFeaturesComponent />
          </div>
          {props.planDetails.catch_line && (
            <div className='catchLineCSS'>
              {props.planDetails.catch_line} 
              {Number(props.planId) === PLAN_SMALL_BUSINESS && 
                (<div className='tc-icon'>
                    *T&C
                </div>)
              }
            </div>
          )}
          {props.planDetails.recommended === true &&
            showRecommendedPlanButton()}
          <div className='planBottomDiv'>
            <button
              onClick={() =>
                props.handleUpdatePlan(props.planId , props.page)
              }
              className={`${renderButtonCSS(
                false,
                props.currentPlanId === props.planId
              )}`}
              type='button'
              disabled={props.currentPlanId === props.planId}
            >
              <span className='Polaris-Button__Content'>
                <span className='Polaris-Button__Text'>
                  {props.currentPlanId === props.planId
                    ? 'Subscribed'
                    : 'Subscribe'}
                </span>
              </span>
              {props.isLoading && props.selectedPlanId === props.planId && (
                <span className='ml-1'>
                  <Spinner size='small' />
                </span>
              )}
            </button>
            {props.planDetails.note && 
              <span className='planBottomNote'
                dangerouslySetInnerHTML={{
                  __html: props.planDetails.note,
                }}
              />
            }
          </div>
        </div>
      </Layout.Section>
    </Fragment>
  );
};

export default PlanComponent;
